export const DEALER_CENTER_GLOBAL_NAV_PATH = 'dealer-center/includes/global-nav';
export const ALL_DIGITAL_CHECKOUT_PAGE_NAME = 'all-digital-checkout';
